import styled from 'styled-components';

import { Breakpoint, Color, DirectionEnum, FontWeight } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Image } from '../image/image.component';
import { Markdown } from '../markdown/markdown.component';

import { ContainerProps, NewsContainerProps } from './newsSection.types';

export const Container: StyledComponent<'div', ContainerProps> = styled.div<ContainerProps>`
  display: flex;
  flex-direction: ${({ $imagePosition }: ContainerProps): string => $imagePosition === DirectionEnum.Right ? 'row' : 'row-reverse'};
  justify-content: space-between;
  align-items: center;
  width: 100%;

  @media ${Breakpoint.Mobile} {
    flex-direction: column-reverse;
  }
`;

export const NewsContainer: StyledComponent<'div', NewsContainerProps> = styled.div<NewsContainerProps>`
  max-width: 400px;
  width: 100%;
  ${({ $imagePosition }: NewsContainerProps): string => $imagePosition === DirectionEnum.Right 
    ? 'margin-right: 32px' 
    : 'margin-left: 32px'
};

  @media ${Breakpoint.Mobile} {
    max-width: 480px;
    margin-top: 32px;
    ${({ $imagePosition }: NewsContainerProps): string => $imagePosition === DirectionEnum.Right ? 'margin-right: 0' : 'margin-left: 0'};
  }
`;

export const Title: StyledComponent<'h2'> = styled.h2`
  font-weight: ${FontWeight.Medium};
  font-size: 22px;
  line-height: 28px;
  letter-spacing: -0.01em;
  color: ${Color.Black};
  margin-bottom: 24px;
`;

export const Description: StyledComponent<typeof Markdown> = styled(Markdown)`
  font-weight: ${FontWeight.Light};
  font-size: 16px;
  line-height: 22px;
  color: ${Color.Black};
  display: inline-block;
  margin-bottom: 32px;

  p + p {
    margin-top: 12px;
  }
`;

export const ImageContainer: StyledComponent<'div'> = styled.div`
  max-width: 480px;
  width: 100%;
  height: 300px;
  flex-shrink: 0;

  @media ${Breakpoint.Mobile} {
    flex-shrink: 1;
  }
`;

export const ImageElement: StyledComponent<typeof Image> = styled(Image)`
  object-fit: cover;
  width: 100%;
  height: 100%;
  border-radius: 8px;
`;
